export interface EventMapLabelLayout {
  horizontal: 'left' | 'center' | 'right'
  vertical: 'top' | 'middle' | 'bottom'
  orientation: 'horizontal' | 'vertical'
}

export const DEFAULT_EVENT_MAP_LABEL_LAYOUT: EventMapLabelLayout = {
  horizontal: 'center', vertical: 'middle', orientation: 'horizontal'
}

/** Resolve a centered Pixi text inside the object's local frame, then rotate the frame. */
export function eventMapLabelTransform(
  bounds: { x: number; y: number; width: number; height: number; rotation: number; labelLayout?: EventMapLabelLayout },
  text: { width: number; height: number },
  legacyCenter = { x: bounds.x + bounds.width / 2, y: bounds.y + bounds.height / 2 }
) {
  if (!bounds.labelLayout) return { ...legacyCenter, rotation: 0, scale: 1 }
  const layout = bounds.labelLayout
  const vertical = layout.orientation === 'vertical'
  const width = vertical ? text.height : text.width
  const height = vertical ? text.width : text.height
  const padding = Math.min(8, Math.max(0, Math.min(bounds.width, bounds.height) / 4))
  const scale = Math.max(0, Math.min(1, (bounds.width - padding * 2) / Math.max(1, width), (bounds.height - padding * 2) / Math.max(1, height)))
  const offset = (alignment: string, extent: number, size: number) => alignment === 'left' || alignment === 'top'
    ? -extent / 2 + padding + size * scale / 2
    : alignment === 'right' || alignment === 'bottom' ? extent / 2 - padding - size * scale / 2 : 0
  const dx = offset(layout.horizontal, bounds.width, width)
  const dy = offset(layout.vertical, bounds.height, height)
  const angle = bounds.rotation * Math.PI / 180
  return {
    x: bounds.x + bounds.width / 2 + dx * Math.cos(angle) - dy * Math.sin(angle),
    y: bounds.y + bounds.height / 2 + dx * Math.sin(angle) + dy * Math.cos(angle),
    rotation: angle + (vertical ? Math.PI / 2 : 0),
    scale
  }
}
